<template>
  <v-container fluid>
    <div>
      <!-- Automatically updated by .gitlab-ci.yml -->
      Branch: bugfix/1.4.4<br />
      Commit: 2ff60782<br />
      Build Date: 2024-02-05T21:36:52Z
    </div>
  </v-container>
</template>

<script>
/* eslint-disable indent */
  export default {
    name: 'Version'
  };
</script>
<style scoped>
  img {
    height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// version.vue